import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SettingsPlanProPage } from './settings-plan-pro';

@NgModule({
  declarations: [
    SettingsPlanProPage
  ],
  imports: [
    IonicPageModule.forChild(SettingsPlanProPage)
  ]
})
export class SettingsPlanProPageModule {}



// WEBPACK FOOTER //
// ./src/pages/settings-plan-pro/settings-plan-pro.module.ts